export default __webpack_public_path__ + "static/media/cai-design08.1a38df33.jpg";